<template>
<div class="mt-4 prose prose-sm prose-blue">
  
  <p>
    Our DBS Check will inspect your DBS certificate, along with some accompanying information, to ensure it meets our <a @click="showRequirements" class="cursor-pointer">requirements</a>.
    If successful, you will be rewarded with our DBS Shield, on your profile and search results, identifying you as a trusted tutor.
  </p>
  <p class="pl-4 border-l-2 border-l-gray-200 font-medium">
    Clients questioned in a 2022 survey overwhelmingly agreed that they would expect to see an <strong class="font-bold whitespace-nowrap">Enhanced</strong> DBS certificate before starting private tuition.
  </p>

  <h3>
    Get Started
  </h3>
  <p>
    Our DBS Check is provided <strong>free of charge</strong>. If required, you can also purchase a new DBS certificate through us.
  </p>
    
  <div class="flex items-center space-x-3">
    <TailwindButton
      @click="showSubmitDbsForm()"
      class="flex-1 w-40 h-16 sm:flex-initial"
    >
      I already have a DBS certificate
    </TailwindButton>
    <TailwindButton
      @click="showRequestDbsForm()"
      class="flex-1 w-40 h-16 sm:flex-initial"
    >
      I need a new DBS certificate
    </TailwindButton>
  </div>

  <p>
    Not sure if you already meet the requirements? Get in touch at <a href="mailto:support@thetutorindex.com">support@thetutorindex.com</a> and we will be happy to assist.
  </p>

</div>
</template>

<script>
import TailwindButton from '../TailwindButton.vue'

export default {
  components: { TailwindButton },
  methods: {
    showSubmitDbsForm() { this.$emit('showSubmitDbsForm') },
    showRequestDbsForm() { this.$emit('showRequestDbsForm') },
    showRequirements() { this.$emit('showRequirements') }
  }
}
</script>

<style>

</style>